// Store confirmation at app login (CJ 2026-07-31). Now that Monarch's clock is
// retired, checking off tasks / logging waste + shift meals no longer rides on
// an open punch to know which store you're at. Instead, a staff member assigned
// to more than one café confirms the store when they open the app, so those
// entries land on the right store. Single-store staff and managers (who have the
// location switcher) never see this. Choice is remembered for the day.

export function StoreConfirmModal({ user, stores, onConfirm }) {
  const first = (user?.name || '').split(/\s+/)[0];
  return (
    <div style={{ position: 'fixed', inset: 0, background: '#1c1f1d', zIndex: 2000,
                  display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ background: '#fffdf9', borderRadius: 16, maxWidth: 420, width: '100%', padding: '26px 24px',
                    boxShadow: '0 20px 60px rgba(0,0,0,.4)', textAlign: 'center' }}>
        <div style={{ fontSize: 11, letterSpacing: '.16em', textTransform: 'uppercase', color: '#b0842f', fontWeight: 700 }}>
          Empire Tea &amp; Coffee
        </div>
        <div style={{ fontFamily: 'var(--serif, Georgia)', fontSize: 24, fontWeight: 700, margin: '8px 0 4px', color: '#241d14' }}>
          {first ? `Hi ${first} —` : 'Welcome —'} which store today?
        </div>
        <div style={{ fontSize: 13.5, color: '#5f5443', marginBottom: 18, lineHeight: 1.5 }}>
          Pick where you're working so your tasks, waste, and shift meals land on the right store.
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {stores.map((s) => (
            <button key={s.id} onClick={() => onConfirm(s)}
              style={{ padding: '14px 18px', fontSize: 16, fontWeight: 700, fontFamily: 'inherit', cursor: 'pointer',
                       background: '#2c6247', color: '#fff', border: 'none', borderRadius: 11 }}>
              {s.name}
            </button>
          ))}
        </div>
        <div style={{ fontSize: 11.5, color: '#8d8169', marginTop: 16 }}>
          You can switch stores anytime from the menu.
        </div>
      </div>
    </div>
  );
}
